export const Headphone: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41.382"
      height="40"
      viewBox="0 0 41.382 40"
      {...props}
    >
      <g transform="translate(-3219.425 -424.299)">
        <g transform="translate(3246.635 445.766)">
          <path
            d="M3461.981,630.725h0a9.052,9.052,0,0,1-2.309-.3l-.049-.015a2.979,2.979,0,0,1-1.881-3.771l4.153-12.412a2.976,2.976,0,0,1,3.775-1.878.814.814,0,0,1,.081.032l1.384.642a8.014,8.014,0,0,1,3.914,10.543l-.837,1.847A9.055,9.055,0,0,1,3461.981,630.725Zm-1.874-1.84a7.434,7.434,0,0,0,8.649-4.131l.837-1.847a6.41,6.41,0,0,0-3.131-8.432l-1.339-.622a1.377,1.377,0,0,0-1.711.882l-4.153,12.412a1.38,1.38,0,0,0,.849,1.739Z"
            transform="translate(-3457.586 -612.192)"
            fill="currentColor"
          />
        </g>
        <g transform="translate(3219.425 445.766)">
          <path
            d="M3229.2,630.725a9.056,9.056,0,0,1-8.232-5.311l-.837-1.847a8.014,8.014,0,0,1,3.914-10.543l1.384-.642a.8.8,0,0,1,.082-.032,2.976,2.976,0,0,1,3.775,1.878l4.153,12.412a2.98,2.98,0,0,1-1.881,3.771l-.05.015A9.048,9.048,0,0,1,3229.2,630.725Zm-3.141-16.872-1.34.622a6.409,6.409,0,0,0-3.131,8.432l.836,1.847a7.434,7.434,0,0,0,8.649,4.131,1.379,1.379,0,0,0,.849-1.739l-4.153-12.412a1.376,1.376,0,0,0-1.71-.882Z"
            transform="translate(-3219.425 -612.192)"
            fill="currentColor"
          />
        </g>
        <g transform="translate(3221.075 424.299)">
          <path
            d="M3270.777,449.639a.8.8,0,0,1-.783-.966,21.994,21.994,0,0,0,.475-4.559c0-10.725-7.2-18.215-17.5-18.215s-17.5,7.49-17.5,18.215a21.932,21.932,0,0,0,.455,4.464.8.8,0,0,1-1.566.326,23.555,23.555,0,0,1-.489-4.79c0-11.667,7.854-19.815,19.1-19.815s19.1,8.148,19.1,19.815a23.592,23.592,0,0,1-.51,4.891A.8.8,0,0,1,3270.777,449.639Z"
            transform="translate(-3233.868 -424.299)"
            fill="currentColor"
          />
        </g>
        <g transform="translate(3227.299 427.844)">
          <path
            d="M3291.546,459.874a.8.8,0,0,1-.423-.121l-2.4-1.5a.8.8,0,1,1,.846-1.358l2.014,1.255,1.775-.919a17.123,17.123,0,0,1,15.728,0l1.744.9,2.042-1.253a.8.8,0,1,1,.837,1.363l-2.427,1.489a.8.8,0,0,1-.786.029l-2.145-1.111a15.521,15.521,0,0,0-14.257,0l-2.179,1.128A.8.8,0,0,1,3291.546,459.874Z"
            transform="translate(-3288.345 -455.323)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};
